<template>
  <div class="literature">
    <div class="item">
      <div class="title">关键词</div>
      <el-row>
        <el-col :span="15">
          <el-input v-model="query"  size="mini" />
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button type="primary" size="mini">查询</el-button>
          <el-button size="mini" @click="handlerClear">清除</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="item">
      <div class="title">查询结果</div>
      <ul class="lists">
        <li v-for="(item, index) in list" :key="index" :class="[{'active': active === item}]">
          [] 李稻葵, 刘霖林, 王红领. GDP中劳动份额演变的U型规律[J]. 经济研究, 2009(1):70-82.
        </li>
      </ul>
    </div>
    <div class="btn">
      <el-button type="primary" size="medium" @click="add">生成</el-button>
      <el-button type="primary" size="medium" @click="handleReplace">替换</el-button>
      <el-button type="info" size="medium" @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>
import dlgFunc from '../textProofreading/index.js';

export default {
  name: 'literature',
  data() {
    return {
      query: '',
      active: '[] 李稻葵, 刘霖林, 王红领. GDP中劳动份额演变的U型规律[J]. 经济研究, 2009(1):70-82.',
      list: ['[] 李稻葵, 刘霖林, 王红领. GDP中劳动份额演变的U型规律[J]. 经济研究, 2009(1):70-82.', ' [] 李稻葵, 刘霖林, 王红领. GDP中劳动份额演变的U型规律[J]. 经wewe济研究, 2009(1):70-82.'],
      // 选中对象
      selection: {},
    };
  },
  created() {
    this.selection = dlgFunc.CWps.Application.ActiveDocument.ActiveWindow.Selection;
    // 当前段落文本
    this.query = dlgFunc.CWps.Application.Selection.Paragraphs.Item(1).Range.Text;
  },
  methods: {
    handlerClear() {
      this.query = '';
      this.active = '';
      this.list = [];
    },
    close() {
      window.close();
    },
    handleReplace() {
      dlgFunc.CWps.Application.Selection.Paragraphs.Item(1).Range.Text = this.active;
    },
    add() {
      // dlgFunc.CWps.ActiveDocument.ActiveWindow.Selection.InsertParagraph()
      dlgFunc.CWps.Application.ActiveDocument.ActiveWindow.Selection.InsertAfter(this.active);
    }
  }
}
</script>

<style scoped>
.literature {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #F4F4F4
}

.item {
  background-color: #fff;
  border-radius: 5px;
  padding: 15px 20px;
  margin: 10px;
}

.title {
  font-size: 16px;
  padding-bottom: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}

.lists {
  height: 200px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

li {
  list-style-type: none;
  font-size: 12px;
  padding: 4px;
  border: 1px dashed #E8E8E8;
}

.active {
  background-color: #1890FF;
  color: #fff;
}

.btn {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
}
</style>